export var getObjectKeys = function getObjectKeys(obj) {
  return Object.keys(obj);
};
export var getObjectValues = function getObjectValues(obj) {
  return Object.values(obj);
};
export var getObjectEntries = function getObjectEntries(obj) {
  return Object.entries(obj);
};
export var objectHas = function objectHas(obj, key) {
  return Reflect.has(obj, key);
};
//# sourceMappingURL=object.js.map